import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import course03 from "../../../course/course-03/course";
import lesson0213 from "../lesson-13/lesson";
import lesson0302 from "../../course-03/lesson-02/lesson";
import lesson0316 from "../../course-03/lesson-16/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "0e7d92fd-42c7-42b9-b437-b7138fdc9cb4",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0213),
    lesson: lesson0213,
  },
  {
    id: "c4f5016f-285e-4947-bd42-fd1e2493c45c",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0302),
    lesson: lesson0302,
  },
  {
    id: "59823239-800f-468d-977d-883271c5f847",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0316),
    lesson: lesson0316,
  },
];

export default lessonLinks;
